module.exports = __webpack_public_path__ + "img/Dantam Hair 25.9715db47.jpg";